import { render, staticRenderFns } from "./ComboBox.vue?vue&type=template&id=87c7cb6a&scoped=true&"
import script from "./ComboBox.vue?vue&type=script&lang=ts&"
export * from "./ComboBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c7cb6a",
  null
  
)

export default component.exports